/**
 * LUXEL Variant Fix v2
 * Corrige la selección inicial de la variante "Padre / Padre" ($0.00)
 * creada por Whatmore en todos los productos de la tienda.
 *
 * Usa la lógica nativa de Tinker: simplemente dispara el evento 'change'
 * en el radio correcto y variant-picker.js hace el resto.
 *
 * Selector corregido: fieldset[ref="fieldsets[]"]
 */
(function () {
  'use strict';

  function fixVariantSelection(container) {
    // Selector exacto según snippets/variant-main-picker.liquid
    var fieldsets = Array.from(
      container.querySelectorAll('fieldset[ref="fieldsets[]"]')
    );
    if (fieldsets.length === 0) return;

    // Revisar el primer fieldset — si tiene "Padre" seleccionado, corregir
    var firstFieldset = fieldsets[0];
    var currentChecked = firstFieldset.querySelector('input[type="radio"]:checked');

    // Si no hay "Padre" seleccionado, no hacer nada
    if (!currentChecked || currentChecked.value !== 'Padre') return;

    // Buscar el primer radio válido: valor != "Padre" y disponible
    var radios = Array.from(firstFieldset.querySelectorAll('input[type="radio"]'));
    var validRadio = null;

    // Primero: disponible y no "Padre"
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value !== 'Padre' && radios[i].dataset.optionAvailable !== 'false') {
        validRadio = radios[i];
        break;
      }
    }
    // Fallback: cualquiera que no sea "Padre"
    if (!validRadio) {
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].value !== 'Padre') {
          validRadio = radios[j];
          break;
        }
      }
    }

    if (!validRadio) return;

    // Marcar como checked y disparar el evento change nativo
    // Tinker's variant-picker.js captura este evento y hace fetchUpdatedSection()
    // que actualiza precio, variante ID, botón y URL automáticamente
    validRadio.checked = true;
    validRadio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function observeQuickAddModal() {
    var quickAddDialog = document.getElementById('quick-add-dialog');
    if (!quickAddDialog) return;

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (
          mutations[i].type === 'attributes' &&
          mutations[i].attributeName === 'open' &&
          quickAddDialog.hasAttribute('open')
        ) {
          // Esperar a que Tinker termine de inyectar el contenido del modal
          setTimeout(function () {
            var modalContent = document.getElementById('quick-add-modal-content');
            if (modalContent) fixVariantSelection(modalContent);
          }, 150);
        }
      }
    });

    observer.observe(quickAddDialog, { attributes: true });
  }

  function init() {
    // Página de producto — múltiples selectores para cubrir todos los layouts de Tinker
    var containers = document.querySelectorAll(
      '.product-details, [data-product-grid-content], .product-information, .featured-product'
    );
    containers.forEach(function (c) { fixVariantSelection(c); });

    // Si no encontró contenedor específico, intentar en todo el documento
    if (containers.length === 0) {
      fixVariantSelection(document);
    }

    // Quick Add modal
    observeQuickAddModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // DOM ya listo — ejecutar en el siguiente tick para que
    // variant-picker.js haya registrado sus event listeners
    setTimeout(init, 0);
  }
})();
